import { render, staticRenderFns } from "./processTaskRuleAffairDetail.vue?vue&type=template&id=df593368&"
import script from "./processTaskRuleAffairDetail.vue?vue&type=script&lang=js&"
export * from "./processTaskRuleAffairDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports